import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import {
  ErrorModal,
  SelectControllerVertical,
  SuccessModal,
} from "@components";
import { AnnualBudgetTableColumn } from "./AnnualBudgetPlanTableColumn";

import { useAnnualProcurementPlans } from "@hooks/procurements/annualProcurementPlan/useAnnualProcurementPlans";

import { TablePagination } from "@helpers/tablePagination";

import { AnnualProcurementsResponseType } from "@type/procurements/annualProcurementPlan";
import { Pagination } from "@type/procurements/pagination";
import { useBudgetYearList } from "@hooks/inventory/budget/useBudgetYearList";
import { getConvertedBudgetYearList } from "@helpers/baseDataConvert";

export function AnnualBudgetPlanTable() {
  const { t } = useTranslation();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { annualProcurementPlansState, handleQuery } =
    useAnnualProcurementPlans();

  const { data: budgetYear } = useBudgetYearList();

  const { getData, deleteSuccess, deleteError } = annualProcurementPlansState;
  const { data, pagination } =
    getData || ({} as AnnualProcurementsResponseType);
  const { page, total } = pagination || ({} as Pagination);

  const { control, setValue, register } = useForm();

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    handleQuery("page", page);
  };
  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
    handleQuery("page", page);
  };

  useEffect(() => {
    switch (true) {
      case deleteSuccess: {
        setIsSuccessModalOpen(true);
        break;
      }
      case !!deleteError: {
        setIsErrorModalOpen(true);
        break;
      }
      default: {
        setIsSuccessModalOpen(false);
        setIsErrorModalOpen(false);
        break;
      }
    }
  }, [deleteError, deleteSuccess]);

  return (
    <div className="pt-10">
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      {/* modal end */}

      <Table
        header={{
          title: t("INVENTORY_BUDGET_LIST.TABLE.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },

          buttons: [
            <div className="row pb-0 mb-0">
              <SelectControllerVertical
                label="PROCUREMENT_ANNUAL_PLAN.TABLE.FILTER.YEAR"
                name="office"
                register={{ ...register("year") }}
                options={getConvertedBudgetYearList(budgetYear)}
                setValue={setValue}
                selectAction={(e) => handleQuery("year", e)}
                control={control}
                portal
                withoutLabel
              />
            </div>,
          ],
        }}
        columns={AnnualBudgetTableColumn(t)}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
